const BigTick = ({ x, y }) => {
  return <path d={`M${x},${y - 18}v${-20}`} stroke="#58b5ff" />;
};

export default BigTick;
